import { Fragment } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';
import { ActionItemButton } from '@components/button/src/action-button';
import { IconCreateEvent } from '@components/icons';
import { ActionMenuButtonOptions, ActionModalType } from '@contexts/modal/modal-context.type';
import { MenuItem, MenuItems, Transition } from '@headlessui/react';
import classNames from 'classnames';
export interface MenuButtonActionOptionProps {
  transitionProps: Record<string, string>;
  open: boolean;
  actions: ActionMenuButtonOptions;
  onClickActionItemButton: (key: ActionModalType) => void;
  navigateToCreateEvent?: () => void;
}

export const MenuButtonActionOptions = ({
  transitionProps,
  open,
  actions,
  onClickActionItemButton,
  navigateToCreateEvent,
}: MenuButtonActionOptionProps) => {
  const { t } = useTranslation();
  return (
    <Transition as={Fragment} {...transitionProps} show={open}>
      <MenuItems
        modal={false}
        anchor={{ to: 'bottom end', gap: 16 }}
        className={classNames('z-50 w-80 origin-top-left rounded-md bg-primary focus:outline-hidden shadow-md')}>
        <div className='flex flex-col w-full p-4 gap-2'>
          {Object.entries(actions).map(([key, value]) => {
            const Icon = value.icon;
            return (
              <MenuItem key={key}>
                {({ focus }) => (
                  <ActionItemButton
                    active={focus}
                    key={key}
                    onClick={() => onClickActionItemButton(key as ActionModalType)}
                    Icon={Icon}
                    text={t(`common:actionModal${value.name}Button`)}
                  />
                )}
              </MenuItem>
            );
          })}
          {navigateToCreateEvent && (
            <MenuItem>
              {({ focus }) => (
                <ActionItemButton
                  active={focus}
                  onClick={navigateToCreateEvent}
                  text={t('eventList:buttonCreateEvent')}
                  Icon={IconCreateEvent}
                />
              )}
            </MenuItem>
          )}
        </div>
      </MenuItems>
    </Transition>
  );
};
